import EmbedCodeGenerator from '../../utils/embed';
import isStreamMonkey from '../../utils/isStreamMonkey';

export default class EmbedController {
  constructor(Account, Channel, BoxCaster, StaticRTMP, $rootScope, $scope, $state, $q) {
    'ngInject';

    this.$scope = $scope;
    this.$state = $state;
    this.Account = Account;
    this.Channel = Channel;
    this.BoxCaster = BoxCaster;
    this.StaticRTMP = StaticRTMP;
    this.$q = $q;
    this.account = $rootScope.account;
    this.FeatureFlags = $rootScope.account.feature_flags;
    this.m3u8Enabled =
      !$rootScope.account.extra_features.static_m3u8_disabled &&
      $rootScope.user.can('embed', 'broadcast/*:m3u8');

    const ApiConfig = $rootScope.ApiConfig;
    this.defaultTicketPrice = ApiConfig.ticket.default_price;
    this.minTicketPrice = ApiConfig.ticket.minimum_price;

    this.activeTab = 0;
    this.mediaType = 'broadcasts';
    this.isStreamMonkey = isStreamMonkey(this.account.migration_service_id);
    // Output of embed directive
    this.output = {
      type: 'all',
      channelId: null,
      title: true,
      description: true,
      related: true,
      embedType: 'javascript',
      args: {
        applyBrandColor: true,
        showTitleAndDescription: true,
        showTitle: true,
        showDescription: true,
        showHighlights: false,
        showRelated: true,
        defaultVideo: 'next',
      },
      boxcastLink: '',
      boxcastTVLink: '',
      all_m3u8: '',
      source_m3u8: '',
      channel_m3u8: '',
      single_m3u8: '',
      layout: 'player-with-playlist',
      integrationType: '', //force selection
      mediaType: 'rss',
    };

    if (this.$state.params.channel_id) {
      this.output.type = 'channel';
      this.output.channelId = this.$state.params.channel_id;
    }

    $scope.$watch(
      () => [
        this.activeTab,
        this.output.type,
        this.output.channelId,
        this.output.title,
        this.output.description,
        this.output.related,
        this.output.args,
        this.output.all_m3u8,
        this.output.source_m3u8,
        this.output.channel_m3u8,
        this.output.single_m3u8,
      ],
      (newVal, oldVal) => {
        var [
          activeTab,
          type,
          channelId,
          title,
          description,
          related,
          args,
          all_m3u8,
          source_m3u8,
          channel_m3u8,
          single_m3u8,
        ] = newVal;
        this.output.embedCode3 = EmbedCodeGenerator.v3WidgetEmbed(channelId, args);
        this.output.iframeCode3 = EmbedCodeGenerator.v3IframeEmbed(channelId, args);
        this.output.linkCode3 = EmbedCodeGenerator.v3Link(channelId, args);
        this.output.appCode3 = EmbedCodeGenerator.v3App(channelId, args);
        this.output.highlightsCode3 = EmbedCodeGenerator.v3Highlights(channelId, args);
        this.output.rss3 = EmbedCodeGenerator.v3Rss(channelId, args);
        this.output.audioMRSS3 = EmbedCodeGenerator.v3MRSS(channelId, 'audio', args);
        this.output.videoMRSS3 = EmbedCodeGenerator.v3MRSS(channelId, 'video', args);
        this.output.rokuDirectPublisher = EmbedCodeGenerator.rokuDirectPublisher(channelId, args);
        this.output.audioPodcast3 = EmbedCodeGenerator.v3Podcast(channelId, 'audio', args);
        this.output.videoPodcast3 = EmbedCodeGenerator.v3Podcast(channelId, 'video', args);
        this.output.boxcastLink = BOXCAST_SHOW_URL + channelId;
        this.output.boxcastTVLink = BOXCAST_TV_SHOW_URL + channelId;
        if (type == 'all') {
          this.output.m3u8 = all_m3u8;
        } else if (type == 'source') {
          this.output.m3u8 = source_m3u8;
        } else if (type == 'channel') {
          this.output.m3u8 = channel_m3u8;
        } else if (type == 'single') {
          this.output.m3u8 = single_m3u8;
        }
      },
      true
    );

    this.reload();
  }

  reload() {
    const { account, FeatureFlags, $q, m3u8Enabled } = this;
    this.mediaTokenRestrictions = account.extra_features.media_token_restrictions;
    if (!this.output.channelId) {
      this.output.channelId = account.channel_id;
      this.output.all_m3u8 = account.static_playlist_url;
    }
    this.output.args.market = account.market;

    this.loadingPromises = [];
    this.channels = this.Channel.query({ l: 1000 }, () => {
      let found = false;
      if (this.output.channelId) {
        const channel = _.find(this.channels, (c) => c.id === this.output.channelId);
        if (channel) {
          this.output.channel = channel;
          found = true;
        }
      }
      if (!found) {
        this.output.channel = _.first(this.channels);
      }
      if (m3u8Enabled || FeatureFlags.podcast) {
        this.output.channel_m3u8 = '';
        this.loadingPromises.push(
          this.Channel.get({ id: this.output.channelId }, (c) => {
            this.output.channel = c;
            this.output.channel_m3u8 = c.static_playlist_url;
          }).$promise
        );
      }
    });
    this.loadingPromises.push(this.channels.$promise);
    this.boxcasters = this.BoxCaster.query({ l: 1000, s: 'name' });
    this.staticRTMPs = this.StaticRTMP.query({ l: 1000, s: 'name' });
    this.loadingPromises.push(
      $q.all([this.boxcasters.$promise, this.staticRTMPs.$promise]).then(() => {
        this.boxcasters.forEach((b) => (b.type = 'boxcaster'));
        this.staticRTMPs.forEach((s) => (s.type = 'static_rtmp'));
        this.sourcesCombined = this.boxcasters.concat(this.staticRTMPs);
        this.output.source = _.first(this.sourcesCombined);
      })
    );
  }
}



// WEBPACK FOOTER //
// ./app/pages/embed/embed.js